import React, { useEffect, useState } from "react";
import Styles from "./SuperAdminMainDashboard.module.css";
import { ReactComponent as BarOrange } from "../../../assets/images/Bar_Orange.svg";
import { ReactComponent as BarGreen } from "../../../assets/images/Bar_Green.svg";
import { ReactComponent as BarBlue } from "../../../assets/images/Bar_Blue.svg";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddIcon from "@mui/icons-material/Add";
import GnaAdmin from "../../Modals/Admin/GnaAdmin/GnaAdmin";
import ChargesContainer from "../../Modals/Admin/Charges/ChargesContainer";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAdmins,
  fetchCompany,
  fetchMetrices,
} from "../../../Redux/Slices/gnaAdminSlice";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import CompanyUserSelection from "../../Modals/Admin/CompanyUserSelection/CompanyUserSelection";
import { adminCompanyAccess } from "../../../Services/GNA/AlterApi";
import {
  ErrorMessage,
  SuccessMessage,
} from "../../../commons/Toast/ErrorMessage";
import { useNavigate } from "react-router-dom";
import OnboardingPopup from "./OnboardingPopup/OnboardingPopup";
import MakerChecker from "../MakerChecker/MakerChecker";
import { generateNoca } from "../../../Services/Schedule/schedule";

const SuperAdminMainDashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let metrics = useSelector(
    (state) => state?.gnaAdminSlice?.fetchMetrices?.data
  );
  let companies = useSelector(
    (state) => state?.gnaAdminSlice?.fetchCompany?.data
  );
  const admins = useSelector(
    (state) => state?.gnaAdminSlice?.fetchAdmins?.data
  );
  const role = useSelector((state) => state?.persistedReducer?.userType);

  const [admin, setAdmin] = useState(false);
  const [charges, setCharges] = useState(false);

  const [selction, setSelection] = useState(false);
  const [selected, setSelected] = useState([]);
  const [selId, setSelId] = useState({});
  const [onboardOpen, setOnboardOpen] = useState(false);
  const [viewType, setViewType] = useState(
    role === "MAKER" || role === "CHECKER" ? "MakerChecker" : "Company"
  );

  useEffect(() => {
    dispatch(fetchMetrices());
    dispatch(fetchCompany());
    dispatch(fetchAdmins());
  }, [dispatch]);

  const handleCompanySelection = async (data) => {
    const payload = data?.map((item) => ({
      companyId: selId?.companyId,
      adminUserId: item,
      adminRole: admins?.filter((ele) => ele?.userId === item)?.[0]?.userType,
    }));
    let res = await adminCompanyAccess(payload);
    if (res?.data?.code === 200) {
      dispatch(fetchCompany());
      setSelection(false);
    } else {
      ErrorMessage(res?.data?.error || "Failed to assign companies to admin");
    }
  };
  const handleUpdateCompanySelection = async (data) => {
    if (selected.includes(data)) {
      setSelected((prev) => prev.filter((item) => item !== data));
    }
  };

  const handleViewType = (role) => {
    setViewType(role);
  };

  const handleGenerateNoca = async () => {
    let res = await generateNoca();
    if (res?.data?.code === 200) {
      SuccessMessage(res?.data?.message);
      const base64String = res?.data?.data;

      // Decode Base64 string
      const binaryString = window.atob(base64String);

      // Create a Blob object (represents the file data)
      const blob = new Blob([binaryString], { type: "text/plain" });

      // Create a temporary link element to trigger the download
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "transaction_data.txt"; // Name of the downloaded file

      // Append to body, click, and cleanup
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      ErrorMessage(res?.data?.message || res?.data?.error);
    }
  };

  return (
    <>
      {charges && (
        <ChargesContainer
          open={charges}
          handleClose={() => setCharges(false)}
        />
      )}
      {selction && (
        <CompanyUserSelection
          open={selction}
          handleClose={() => {
            setSelection(false);
            setSelected([]);
            setSelId({});
          }}
          selected={selected}
          type={"Admin"}
          handleSubmit={handleCompanySelection}
          handleSelection={handleUpdateCompanySelection}
        />
      )}
      {admin && <GnaAdmin open={admin} handleClose={() => setAdmin(false)} />}
      {onboardOpen && (
        <OnboardingPopup
          open={onboardOpen}
          handleClose={() => setOnboardOpen(false)}
        />
      )}
      <div className={Styles.mainContainer_sa}>
        <div className={`display_flex_row ${Styles.countMainContainer}`}>
          <div>
            <BarGreen />
            <div className={`${Styles.escrowContainer}`}>
              <div className={Styles.escrowHeading}>Company</div>
              <div>{companies?.length || 0}</div>
            </div>
          </div>
          <div>
            <BarGreen />
            <div className={`${Styles.escrowContainer}`}>
              <div className={Styles.escrowHeading}>Consumer</div>
              <div>{metrics?.totalConsumers || 0}</div>
            </div>
          </div>
          <div>
            <BarBlue />
            <div className={`${Styles.escrowContainer}`}>
              <div className={Styles.escrowHeading}>Generator</div>
              <div>{metrics?.totalGenerators || 0}</div>
            </div>
          </div>
          <div>
            <BarOrange />
            <div className={`${Styles.escrowContainer}`}>
              <div className={Styles.escrowHeading}>Discom</div>
              <div>{metrics?.totalDiscoms || 0}</div>
            </div>
          </div>
          <div>
            <BarGreen />
            <div className={`${Styles.escrowContainer}`}>
              <div className={Styles.escrowHeading}>Traders</div>
              <div>{metrics?.totalTraders || 0}</div>
            </div>
          </div>
          {/* <div
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setOnboardOpen(true);

              setTimeout(() => {
                console.log(
                  "1 second after click - onboardOpen should still be true"
                );
              }, 1000);
            }}
            style={{ cursor: "pointer" }}
          >
            <div className={Styles.addIconCont}>
              <AddIcon style={{ fontSize: "16px", color: "#f1935c" }} />
            </div>
            <div className={`${Styles.escrowContainer}`}>
              <div className={Styles.escrowHeading}>Onboard</div>
              <div>Client</div>
            </div>
          </div> */}
        </div>
        <div className={`display_flex_row ${Styles.configureElement}`}>
          <div
            className={Styles.createAdmin}
            onClick={() =>
              role === "SUPER_ADMIN"
                ? setAdmin(true)
                : role === "CHECKER"
                ? handleGenerateNoca()
                : ""
            }
            style={{
              cursor: `${
                role === "SUPER_ADMIN" || role === "CHECKER"
                  ? "pointer"
                  : "no-drop"
              }`,
            }}
          >
            <BarOrange />
            <div>{role === "SUPER_ADMIN" ? "GNA Admins" : "Generate NOCA"}</div>
          </div>
          <div className={Styles.assignAdmin} onClick={() => setCharges(true)}>
            <BarGreen />
            <div>Charges</div>
          </div>
          <div
            className={Styles.configurePlatform}
            style={{ cursor: "no-drop" }}
          >
            <BarBlue />
            <div>Configure Platform</div>
          </div>
          <div className={`${Styles.createAdmin}`}>
            <BarOrange />
            <div className={`${Styles.escrowContainer}`}>
              <div className={Styles.escrowHeading}>Escrow Bal. (₹)</div>
              <div>{metrics?.totalEscrowAmount?.toFixed(2)}</div>
            </div>
          </div>
        </div>
        <div className={Styles.detailsCompanyContainer}>
          {viewType === "MakerChecker" ? (
            <MakerChecker handleViewType={handleViewType} viewType={viewType} />
          ) : (
            <>
              <div className="display_flex_row tableHeading">
                <div style={{ width: "25%" }}>Company Name</div>
                <div style={{ width: "15%" }}>Date of Registration </div>
                <div style={{ width: "15%" }}>Status</div>
                <div style={{ width: "20%" }}>VID Balance(₹)</div>
                {role === "SUPER_ADMIN" && (
                  <div style={{ width: "15%" }}>Assigned Admin</div>
                )}
                <div style={{ width: "5%" }}>View</div>
              </div>
              <div className={`scroll_bar_y ${Styles.companymainDetails}`}>
                {companies?.map((company, index) => {
                  const totalEscrow =
                    (company?.consumers?.reduce(
                      (sum, c) =>
                        sum +
                        (c?.walletAccount?.amountRemaining || 0) +
                        (c?.walletAccount?.amountBlocked || 0),
                      0
                    ) || 0) +
                    (company?.generators?.reduce(
                      (sum, g) =>
                        sum +
                        (g?.walletAccount?.amountRemaining || 0) +
                        (g?.walletAccount?.amountBlocked || 0),
                      0
                    ) || 0);
                  return (
                    <div className="display_flex_row tableDetails">
                      <div style={{ width: "25%" }}>{company?.companyName}</div>
                      <div style={{ width: "15%" }}>
                        {company?.registeredAt}
                      </div>
                      <div style={{ width: "15%" }}>
                        {company?.accountStatus === "VERIFIED" ? (
                          <span className="accepted">Verified</span>
                        ) : company?.accountStatus === "UN_VERIFIED" ? (
                          <span className="pending">Un-Verified</span>
                        ) : company?.accountStatus === "UN_VERIFIED" ? (
                          <span className="rejected">Hold</span>
                        ) : company?.accountStatus === "REJECTED" ? (
                          <span className="rejected">Rejected</span>
                        ) : (
                          <span className="rejected">InActive</span>
                        )}
                      </div>
                      <div style={{ width: "20%" }}>
                        <b>{totalEscrow?.toFixed(2)}</b>
                      </div>
                      {role === "SUPER_ADMIN" && (
                        <div style={{ width: "15%" }}>
                          {company?.assignedAdmin?.length > 0 ? (
                            <div className="display_flex_row_gap_8">
                              <span>{company?.assignedAdmin?.length}</span>
                              <VisibilityIcon
                                style={{
                                  color: "#f1935c",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                                onClick={() => {
                                  setSelection(true);
                                  setSelected(
                                    company?.assignedAdmin?.map(
                                      (ele) => ele?.userId
                                    )
                                  );
                                  setSelId(company);
                                }}
                              />
                            </div>
                          ) : (
                            <div>
                              <PersonAddIcon
                                style={{
                                  fontSize: "16px",
                                  cursor: "pointer",
                                  color: "#f1935c",
                                }}
                                onClick={() => {
                                  setSelection(true);
                                  setSelId(company);
                                }}
                              />
                            </div>
                          )}
                        </div>
                      )}
                      <div style={{ width: "5%" }}>
                        <VisibilityIcon
                          style={{
                            color: "#f1935c",
                            cursor: "pointer",
                            fontSize: "16px",
                          }}
                          onClick={() =>
                            navigate(
                              `/admin_dashboard_company?id=${company?.companyId}`
                            )
                          }
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SuperAdminMainDashboard;
